import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/input/containers/input.container';

export default function ProgramBasicInfoComponent ({application,applications,onFormChange, selectedProgram}: any) {

  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
         <InputContainer
isDisabled
label="Active"
name="IsActive"
onValueChange={(event: any) => {
  onFormChange({
    value: event,
    field: 'IsActive'
  });
}}
type="checkbox"
value={selectedProgram?.IsActive}
/>

<InputContainer
isDisabled
label="Name"
name="Name"
onValueChange={(event: any) => {
  onFormChange({
    value: event.target.value,
    field: 'Name'
  });
}}
type="text"
value={selectedProgram?.Name}
/>
 
<InputContainer
isDisabled
label="Display Order"
name="DisplayOrder"
onValueChange={(event: any) => {
  onFormChange({
    value: event.target.value,
    field: 'DisplayOrder'
  });
}}
type="number"
value={selectedProgram?.DisplayOrder}
/>
 
<InputContainer
isDisabled
label="Always Enabled"
name="IsAlwaysEnabled"
onValueChange={(event: any) => {
  onFormChange({
    value: event,
    field: 'IsAlwaysEnabled'
  });
}}
type="checkbox"
value={selectedProgram?.IsAlwaysEnabled}
/>
 
<InputContainer
isDisabled
label="Remarks"
name="Remarks"
onValueChange={(event: any) => {
  onFormChange({
    value: event.target.value,
    field: 'Remarks'
  });
}}
type="text"
value={selectedProgram?.Remarks}
/>

 {selectedProgram.IsAlwaysEnabled !== true &&

                <><InputContainer
                isDisabled
                label="Start Date"
                name="StartDateUtc"
                onValueChange={(event: any) => {
                  onFormChange({
                    value: event.target.value,
                    field: 'StartDateUtc'
                  });
                } }
                type="date"
                value={selectedProgram?.StartDateUtc} /><InputContainer
                isDisabled
                  label="End Date"
                  name="EndDateUtc"
                  onValueChange={(event: any) => {
                    onFormChange({
                      value: event.target.value,
                      field: 'EndDateUtc'
                    });
                  } }
                  type="date"
                  value={selectedProgram?.EndDateUtc} /></>
              } 
<InputContainer
isDisabled
label="Description"
name="Description"
onValueChange={(event: any) => {
  onFormChange({
    value: event.target.value,
    field: 'Description'
  });
}}
type="text"
value={selectedProgram?.Description}
/>
</div>
}
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}